import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_441: DocMigration = {
  maxSchemaVersion: "0.0.441",
  description: "Add global parameter value table to plan set template instances",
  apply(json: any) {
    for (const planSetTemplateInstanceId in json.planSetTemplateConfigs) {
      const planSetTemplateConfig = json.planSetTemplateConfigs[planSetTemplateInstanceId];

      // these appear to be missing from newly created configs
      if (!planSetTemplateConfig.parameterValues) {
        planSetTemplateConfig.parameterValues = {};
      }

      planSetTemplateConfig.globalParameterValues = {};
    }

    return json;
  },
};

export default migration_0_0_441;
